module.exports = __webpack_public_path__ + "static/media/fashion-1.15a6a034.jpg";